const state = {
  cachedViews: [],
  area: [], // 省市区数据
  paper: {}, // 论文状态
  notification: false, // 消息状态
};

const mutations = {
  ADD_CACHED_VIEW: (state, view) => {
    // 不重复添加
    if (state.cachedViews.includes(view.name)) return;
    if (!view?.meta?.noCache) {
      state.cachedViews.push(view.name);
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view.name);
    index > -1 && state.cachedViews.splice(index, 1);
  },
  DEL_ALL_CACHED_VIEWS: (state) => {
    state.cachedViews = [];
  },
  SET_AREA: (state, area) => {
    state.area = area;
  },
  SET_PAPER_STAGE: (state, paper) => {
    state.paper = paper;
  },
  SET_NOTIFICATION_STAGE: (state, notification) => {
    state.notification = notification;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
